


import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FieldStatus extends Vue {
    @Prop() public Value!: boolean;
}
